import { connect } from 'react-redux';
import StockConfigure from './StockConfigure';
import { getStockConfigureList, addNewStockLevel, deleteStockLevel } from '../../../store/actions/stockConfigure';

const mapStateToProps = ({ stockConfigureReducer }) => ({ stockConfigureReducer });
const mapDispatchToProps = {
  getStockConfigureList,
  addNewStockLevel,
  deleteStockLevel
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockConfigure);
